import { useEffect, useState } from 'react';
import BonusEarnDetails from '../Components/BonusEarnDetails/BonusEarnDetails';
import { holder, holderBg, mellBg, mellIcon } from '../../../assets';
import { useSelector } from 'react-redux';
import { TRootState } from '../../../store/store';
import { formatNumberString, getToken, setAvas } from '../../../utils/helper';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setHolders } from '../../../store/holders/holders.slice';
import HolderAccount from '../Components/HolderAccount/HolderAccount';

import { Skeleton } from 'antd';
import { Empty } from '../../../generated/google/protobuf/empty';

import { transport } from '../../../utils/constants';
import { DistributionClient } from '../../../generated/mlmbox/client/distribution/distribution.client';
import { Account_Info } from '../../../generated/mlmbox/types/account';

const Holders = () => {
    const holders = useSelector((state: TRootState) => state.holders.value);
    const acc = useSelector((state: TRootState) => state.user.value);
    const [open, setOpen] = useState<Account_Info | null>(null);
    const [loading, setLoading] = useState(!holders);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const distributionClient = new DistributionClient(transport);

    useEffect(() => {
        // if (holders) return;

        distributionClient.holderInfo(Empty, { meta: { authorization: getToken() } }).then(async ({ status, response }) => {
            if (status.code === 'OK') {
                const profiles: Account_Info[] = response.topPartners.map((e) => e.account) as Account_Info[];

                await setAvas(profiles);

                dispatch(setHolders(response));

                setLoading(false);
            }
        });
    }, []);

    return (
        <div className="holders">
            <>
                <div className="holder__details">
                    <BonusEarnDetails
                        loading={loading}
                        icon={holder}
                        value={holders && holders.partnersQuantity ? formatNumberString(String(holders.partnersQuantity)) : '0'}
                        title={t('holder')}
                        bgIcon={holderBg}
                        bgIconPosition={{ top: '15px', right: '0px' }}
                    />
                    <BonusEarnDetails
                        loading={loading}
                        icon={mellIcon}
                        value={holders && holders.partnersHoldBalance ? formatNumberString(String(Number(holders.partnersTurnover))) : '0'}
                        title={t('holders')}
                        bgIcon={mellBg}
                        bgIconPosition={{ top: '8px', right: '-3px' }}
                    />
                </div>

                {!loading &&
                    holders?.topPartners.map((partner, index) => (
                        <HolderAccount
                            // onClick={() => partner.account && setOpen(partner.account)}
                            key={partner.account?.account?.id}
                            holder={partner}
                            index={index}
                        />
                    ))}
                {!loading && holders && holders.topPartners.length === 0 && <p className="not-hold">{t('not_hold')}</p>}

                {loading && (
                    <div className="l">
                        <Skeleton.Node
                            className="hl"
                            style={{ width: '100%', borderRadius: '8px', height: '65px' }}>
                            <Skeleton.Avatar className="hl-av" />
                        </Skeleton.Node>
                    </div>
                )}
            </>
        </div>
    );
};

export default Holders;
